import { Collapse, useMatches } from '@mantine/core';
import { useUncontrolled } from '@mantine/hooks';

import { Alert } from '../../../../Feedback/Alert/Alert';
import { SegmentedControl } from '../../../../Inputs/SegmentedControl/SegmentedControl';
import { Stack } from '../../../../Layout/Stack';

type ChooseDonationDuration = {
  onChange?: (newValue: boolean) => void;
  value?: boolean;
  defaultValue?: boolean;
  formKey?: string;
};

const valuePropsToString = (value?: boolean) => (value ? '1' : '0');

const ChooseDonationDurationButtons = ({
  value,
  onChange,
  defaultValue,
  formKey,
}: ChooseDonationDuration) => {
  const [_value, handleChange] = useUncontrolled({
    value: valuePropsToString(value),
    defaultValue: valuePropsToString(defaultValue),
    finalValue: '0',
    onChange: (value) => {
      if (onChange) {
        onChange(value === '1');
      }
    },
  });
  const orientation: 'horizontal' | 'vertical' | undefined = useMatches({
    sm: 'horizontal',
    xs: 'vertical',
  });

  return (
    <Stack gap="sm">
      <SegmentedControl
        data={[
          { label: `One-time`, value: '0' },
          { label: ` Monthly`, value: '1' },
        ]}
        orientation={orientation}
        variant="light"
        defaultValue={_value}
        onChange={handleChange}
        w="100%"
        key={formKey}
      />

      <Collapse in={_value == '1'}>
        <Alert.Transition type="info-blue" mounted={_value == '1'}>
          Since you've chosen to make a recurring donation, you'll be charged this amount each
          month. You'll be able to edit or cancel your recurring donation at any time.
        </Alert.Transition>
      </Collapse>
    </Stack>
  );
};

export { ChooseDonationDurationButtons };
